var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 5V15C3.625 15.3315 3.7567 15.6495 3.99112 15.8839C4.22554 16.1183 4.54348 16.25 4.875 16.25H17.375C17.5408 16.25 17.6997 16.1842 17.8169 16.0669C17.9342 15.9497 18 15.7908 18 15.625V6.875C18 6.70924 17.9342 6.55027 17.8169 6.43306C17.6997 6.31585 17.5408 6.25 17.375 6.25H4.875C4.54348 6.25 4.22554 6.1183 3.99112 5.88388C3.7567 5.64946 3.625 5.33152 3.625 5ZM3.625 5C3.625 4.66848 3.7567 4.35054 3.99112 4.11612C4.22554 3.8817 4.54348 3.75 4.875 3.75H15.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 12.1875C15.0803 12.1875 15.5 11.7678 15.5 11.25C15.5 10.7322 15.0803 10.3125 14.5625 10.3125C14.0447 10.3125 13.625 10.7322 13.625 11.25C13.625 11.7678 14.0447 12.1875 14.5625 12.1875Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.48b78304d0c79177f716a973382d0333.svg";
export { ForwardRef as ReactComponent };